import { render, staticRenderFns } from "./ListAjustesNomina.vue?vue&type=template&id=4bbb050c&"
import script from "./ListAjustesNomina.vue?vue&type=script&lang=js&"
export * from "./ListAjustesNomina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports